module.exports = __webpack_public_path__ + "static/img_9718-d14552b41fe9a2387b61def3e22f0823.jpg";